import React from 'react';
import useBreakpoints from 'hooks/useBreakpoints';
import { getBreakpointValue } from 'utils/ui';
import UserBadgeImage from 'components/UserBadgeImage';
function ResponsiveUserBadgeImage(_ref) {
  var badge = _ref.badge,
    hasUserBadge = _ref.hasUserBadge,
    sizes = _ref.sizes,
    breakpoints = _ref.breakpoints;
  var _useBreakpoints = useBreakpoints(breakpoints),
    currentBreakpoint = _useBreakpoints.currentBreakpoint;
  if (!badge) {
    return null;
  }
  return /*#__PURE__*/React.createElement(UserBadgeImage, {
    badge: badge,
    hasUserBadge: !!hasUserBadge,
    size: getBreakpointValue(sizes, breakpoints, currentBreakpoint)
  });
}
export default ResponsiveUserBadgeImage;